import React from "react";
import { connect } from "react-redux";
import {
  Button,
  CssBaseline,
  Grid,
  Typography,
  Container,
  withStyles,
  Box,
} from "@material-ui/core";
import { NavLink as RouterLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import { AdminActions } from "../../redux/actions/AdminActions";
import AdminRecordList from "./AdminRecordList";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(1),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    transition: "box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    backgroundColor: "#fff",
  },
  avatar: {
    margin: theme.spacing(3),
  },
  typography: {
    margin: theme.spacing(3),
    fontFamily: ["Josefin Sans", "sans-serif"].join(","),
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(3),
  },
  buttons: {
    display: "flex",
    justifyContent: "flex-end",
  },
  button: {
    marginTop: theme.spacing(1),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
});

class AdminList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      submitted: false,
    };
  }

  componentDidMount() {
    this.props.getAllAdmin();
  }

  componentWillUnmount() {
    this.props.clearAll();
  }

  getAdminList() {
    let adminList = [];
    if (this.props.adminList && this.props.adminList) {
      return this.props.adminList;
    } else {
      adminList = [];
    }
    return adminList;
  }

  render() {
    const classes = this.props.classes;
    return (
      <>
        <Helmet>
          <title>RxRapidMad | Admin list</title>
        </Helmet>
        <Container component="main" maxWidth={false}>
          <CssBaseline />

          <form
            className={classes.form}
            noValidate
            onSubmit={this.handleSubmit}
          >
            <Box pb={{ xs: 2 }}>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={8} md={8}>
                  <Box>
                    <Typography gutterBottom variant="h4" color="primary">
                      Admin list
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <Box className={classes.buttons}>
                    <Button
                      component={RouterLink}
                      variant="button"
                      variant="contained"
                      color="primary"
                      href="#contained-buttons"
                      to="/admin/add"
                    >
                      Add new admin
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </form>
          <AdminRecordList adminList={this.getAdminList()}></AdminRecordList>
        </Container>
      </>
    );
  }
}

function mapStateToProps(state) {
  const adminList = state.admin.adminList;
  return { adminList };
}

const mapDispatchToProps = (dispatch) => {
  return {
    getAllAdmin: () => dispatch(AdminActions.getAllAdmin()),
    clearAll: () => dispatch(AdminActions.clearAdmin()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles, { withTheme: true })(AdminList));
